import { IAppEntity } from "src/config/entities";
import React from "react";
import { ReferenceTypes } from "src/enums/ReferenceTypes";
import { DocumentPostStatusEnum } from "src/enums/DocumentPostStatusEnum";
import { WriteOffGoodsDetail } from "src/components/Pages/Documents/Warehouse/WriteOffGoods/components/WriteOffGoodsDetail";
import WriteOffGoodsList from "src/components/Pages/Documents/Warehouse/WriteOffGoods/components/WriteOffGoodsList";
import { NFLookupWriteOffGoods } from "src/components/Shared/NewForms/NFLookupWriteOffGoods";
import { WriteOfGOodsService } from "src/services/documents/WriteOffGoodsService";
import { WriteOffGoodsDto } from "src/components/Pages/Documents/Warehouse/WriteOffGoods/dtos/WriteOffGoodsDto";
import { WriteOffGoodsOperationTypeEnum } from "src/components/Pages/Documents/Warehouse/WriteOffGoods/dtos/WriteOffGoodsOperationTypeEnum";

export const WriteOffGoods: IAppEntity = {
  entityType: "document",
  title: "Write Off Goods",
  pluralTitle: "Write Off Goods",
  apiUrl: "WriteOffGoods",
  apiEnum: ReferenceTypes.DocumentWriteOffGood,
  getDetailView: (id?: string) => {
    return React.createElement(WriteOffGoodsDetail, {
      id: id
    });
  },
  getDetailViewComponent: (model: any, modelUpdatedEvent: (model: any) => void) => React.createElement(React.Fragment, {}),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(WriteOffGoodsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent
    }),

  getLookupComponent(model: any): any {
    return React.createElement(NFLookupWriteOffGoods, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog
    });
  },
  getDataService: () => new WriteOfGOodsService("WriteOffGoods"),
  getEmptyModel: () => {
    const model: WriteOffGoodsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: DocumentPostStatusEnum.Draft,
      documentDate: new Date(),
      createdDate: new Date(),
      products: [],
      operationType: WriteOffGoodsOperationTypeEnum.TaxableWriteOff
      // products: [],
      // services: [],
      // paymentOffsets: [],
    };
    return model;
  }
};
